import { createSelector } from '@reduxjs/toolkit';

import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const selectChatHeader = createSelector(currentOpenChatSelector, currentChat => currentChat?.header);
